(function () {
    'use strict';

    angular.module("imApp").factory("stockIncomingService", ['$ihttp', function ($ihttp) {
        let service = {
            listStockIncomings: function (parms) {
                return $ihttp.post({
                    method: 421,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
